/**
 * Compare URL API 함수들
 */

import { AuthContextType } from "../auth/AuthContext";
import { api } from "../../shared/api";
import { apiHost, getErrorMessage } from "../../shared/api/helpers";

/**
 * 동일마켓 필터링 규칙 적용
 */
function getSameMarketFilter(compare_site: string, market_site: string): string[] | null {
  let rv = null;
  if (compare_site == 'danawa' && market_site == 'auction') {        // danawa, auction
    rv = ['EE715']
  } else if (compare_site == 'danawa' && market_site == 'gmarket') { // danawa, gmarket
    rv = ['EE128']
  } else if (compare_site == 'enrui' && market_site == 'auction') { // enuri, auction
    rv = ['4027']
  } else if (compare_site == 'enrui' && market_site == 'gmarket') { // enuri, gmarket
    rv = ['536']
  }
  return rv
}

export async function getCompareUrlData(opts: {
  auth: AuthContextType,
  compare_site: string,
  compare_url: string,
  compare_column?: string,
  compare_pages: number,
  compare_range: string,
  include_shipping_fee?: boolean,
  extra_config?: { naver_ungroup_sellers?: boolean; [key: string]: unknown },
  target_rank?: number,
  shop_site?: string,
  shop_id?: string,
  shop_item_id?: string,
  shop_item_image_url?: string,
  setProcessMessage?: (arg?: any) => void;
  setErrorMessage?: (arg?: any) => void;
  setResult?: (arg?: any) => void;
}) {
  const {
    auth,
    compare_site,
    compare_url,
    compare_column,
    compare_pages,
    compare_range,
    include_shipping_fee,
    extra_config,
    target_rank,
    shop_site,
    shop_id,
    shop_item_id,
    shop_item_image_url,
    setErrorMessage, setProcessMessage, setResult
  } = opts;
  try {
    setErrorMessage && setErrorMessage(null); // Reset error state
    setProcessMessage && setProcessMessage("비교 URL을 확인 중입니다..."); // Set loading state
    const url = `${apiHost}/api/compare_url/`;
    const payload: Record<string, any> = {
      compare_url,
      compare_site,
      compare_column,
      compare_pages,
      compare_range,
      include_shipping_fee,
      extra_config,
      shop_site,
      shop_id,
      target_rank,
      shop_item_id,
      shop_item_image_url,
    }
    if (compare_range == 'items_same_market') { // 동일마켓 필터링
      payload['filter_mall_ids'] = getSameMarketFilter(compare_site, shop_site || '')
    }
    // Django의 비교 조회 제한 80초 이후 응답을 받을 수 있도록 여유를 둔다.
    const response = await api.post(url, payload, { timeout: 90_000 });
    if (response.data && setResult) {
      setResult(response.data);
    }
  } catch (error: any) {
    if (error.response?.status === 401) {
      await auth?.logout();
    }
    const message = getErrorMessage(error);
    if (setErrorMessage) {
      setErrorMessage(message);
    } else {
      console.error(message);
    }
  } finally {
    setProcessMessage && setProcessMessage("");
  }
}

export interface CompareItemUrlData {
  url: string;
  title?: string;
  mall_seller_name?: string;
  price: number;
  price_sale?: number;
  discount?: number;
  discount_by_market?: number;
  shipping_fee?: number;
}

export async function fetchCompareItemUrlData(opts: {
  compare_item_url: string;
  compare_site: string;
  shop_site?: string;
  shop_id?: string;
}): Promise<CompareItemUrlData> {
  const response = await api.post(
    `${apiHost}/api/compare_item_url/`, opts, { timeout: 75_000 },
  );
  return response.data.data;
}
